// <copyright file="quote-item-validation-explanation.ts" company="SoftTech Ltd">
// Copyright (c) SoftTech Ltd. All rights reserved.
// </copyright>

import { LangQuoteItemValidationModal } from '../../../localization/scripts/quotes/views/quote-item-validation-modal-lang';

/** An item's customer code versions when it is out of date because that version was raised (SUPVER-008). */
export interface CustomerVersions {
  itemVersion: number;
  currentVersion: number;
}

/**
 * The out-of-date products explanation. When any item is out of date because the supplier raised its customer
 * code's version (SUPVER-008), the dealer is told the supplier updated this dealership branch's settings, ahead of
 * today's text; otherwise today's text alone. The versions are shown per row, each against its own supplier's.
 */
export function outOfDateExplanation(
  supplierVersion: string,
  priceAdjComent: string,
  itemCustomerVersions: (CustomerVersions | undefined)[]
): string {
  const explanation = LangQuoteItemValidationModal.explanation({ version: supplierVersion, priceAdjComent });
  if (!itemCustomerVersions.some(x => x !== undefined)) return explanation;
  return `${LangQuoteItemValidationModal.customerVersionExplanation()}\n\n${explanation}`;
}

/**
 * The version column: today's value, plus the customer code version the item was configured on beside its
 * supplier's current one (SUPVER-008).
 */
export function outOfDateVersionText(displayValue: string, customerVersions: CustomerVersions | undefined): string {
  if (!customerVersions) return displayValue;
  const versions = { version: customerVersions.itemVersion, currentVersion: customerVersions.currentVersion };
  return displayValue
    ? LangQuoteItemValidationModal.itemCustomerVersionAfter({ displayValue, ...versions })
    : LangQuoteItemValidationModal.itemCustomerVersion(versions);
}
